
export enum RestoreTier {
  Expedited = 'Expedited',
  Standard = 'Standard',
  Bulk = 'Bulk',
}
export interface RestoreMediaRequestDto {
  tier: RestoreTier;
  retentionDays: number;
}
